import { IStyleConfig, mergeStyles, RangeInputGroup } from '@cian/components';
import * as React from 'react';

const style = require('./index.css');

export interface IFromToInputProps {
  onValueChange(value: number): void;
  // tslint:disable-next-line:no-any
  onBlur?(event: any): void;
  value?: number;
  placeholder?: string;
  inputStyle?: IStyleConfig;
  error?: boolean;
  errorText?: string;
  disableNegative?: boolean;
  disablePrettyFormating?: boolean;
  maxLength?: number;
}

export interface IFromToControlProps {
  from: IFromToInputProps;
  to: IFromToInputProps;
  rangeGroupStyle?: IStyleConfig;
  errorTextCommon?: string;
}

export const FromToControl = (props: IFromToControlProps) => {
  const { errorTextCommon, to, from, rangeGroupStyle } = props;

  const isInvalidRange = !!(from.value && to.value && from.value > to.value);

  return (
    <RangeInputGroup
      errorTextCommon={errorTextCommon}
      min={{
        disableNegative: from.disableNegative,
        disablePrettyFormating: from.disablePrettyFormating,
        error: from.error,
        errorText: from.errorText,
        id: 'min-0',
        value: from.value,
        name: 'min',
        placeholder: from.placeholder || 'от',
        inputStyle: mergeStyles(
          style['fromToControl-input'],
          isInvalidRange && style['error'],
          from.inputStyle,
          // tslint:disable-next-line:no-any
        ) as any,
        onBlur: from.onBlur,
        maxLength: from.maxLength,
        // tslint:disable-next-line:no-any
        onValueChange: (value: any) => {
          from.onValueChange(value);
        },
      }}
      max={{
        disableNegative: to.disableNegative,
        disablePrettyFormating: to.disablePrettyFormating,
        error: to.error,
        errorText: to.errorText,
        id: 'max-0',
        value: to.value,
        name: 'max',
        maxLength: to.maxLength,
        placeholder: to.placeholder || 'до',
        inputStyle: mergeStyles(
          style['fromToControl-input'],
          isInvalidRange && style['error'],
          to.inputStyle,
          // tslint:disable-next-line: no-any
        ) as any,
        onBlur: to.onBlur,
        // tslint:disable-next-line:no-any
        onValueChange: (value: any) => {
          to.onValueChange(value);
        },
      }}
      // tslint:disable-next-line: no-any
      rangeGroupStyle={mergeStyles(style['fromToControl'], rangeGroupStyle) as any}
    />
  );
};
